<template>
	<div>
		<h4>Constancia electrónica de riesgos</h4>
		<p class="mt-5">
			Completa la siguiente constancia para estar seguros de que conoces las implicaciones de invertir en
			RedGirasol.
		</p>
		<div class="main-form mt-5">
			<div class="vx-row mt-4">
				<div :class="colClassFull">
					<div class="mb-base" v-for="risk in risksData" :key="risk.index">
						<vs-row vs-w="12" vs-justify="center" vs-align="center" vs-type="flex">
							<vs-col vs-justify="center" vs-align="center" vs-lg="7">
								<div class="flex flex-wrap justify-start">
									<label class="bold">{{ risk.title }}</label>
								</div>
								<small>{{ risk.subtitle }}</small>
								<br>
								<span v-if="risk.subtitle2">
									<br>
									<small>{{ risk.subtitle2 }}</small>
									<br>
								</span>
								<br>
								<small class="bold">{{ risk.question }}</small>
							</vs-col>
							<vs-col vs-justify="center" vs-align="center" vs-lg="5">
								<div class="flex flex-wrap justify-start ml-2">
									<template v-if="risk.value == 0">
										<vs-radio disabled :vs-name="risk.title + '_1'" color="dark" class="w-full mb-2"
											v-model="riskRadioAnswers[risk.value]" :vs-value="1">Sí</vs-radio>
										<vs-radio :vs-name="risk.title + '_0'" color="dark" class="w-full"
											v-model="riskRadioAnswers[risk.value]" :vs-value="0">No</vs-radio>
									</template>
									<template v-else>
										<vs-radio :vs-name="risk.title + '_1'" color="dark" class="w-full mb-2"
											v-model="riskRadioAnswers[risk.value]" :vs-value="1">Sí</vs-radio>
										<vs-radio disabled :vs-name="risk.title + '_0'" color="dark" class="w-full"
											v-model="riskRadioAnswers[risk.value]" :vs-value="0">No</vs-radio>
									</template>
								</div>
							</vs-col>
						</vs-row>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import defaultParametersHelper from '@mixins/defaultParametersHelper';
import formatHelper from '@mixins/formatHelper';
export default {
	name: "LatestInvestorRisksContract",
	mixins: [defaultParametersHelper, formatHelper],
	data() {
		return {
			colClassFull: "vx-col w-full",
			colClass: "vx-col md:w-1/2 sm:w-full w-full mb-5",
			riskRadioAnswers: [
				0, 1, 1, 1, 1, 1, 1
			],
			maxEffectiveInvestmentWithdrawalPerInvestorPerDayParam: 0

		};
	},
	async mounted() {
		this.maxEffectiveInvestmentWithdrawalPerInvestorPerDayParam = await this.getPublicParam('max_effective_investment_withdrawal_per_investor_per_day');
	},
	computed: {
		maxEffectiveInvestmentWithdrawalPerInvestorPerDay() {
			return this.mxnFormat(this.maxEffectiveInvestmentWithdrawalPerInvestorPerDayParam);
		},
		risksData() {
			return [
				{
					title: 'Sin asesoría',
					subtitle: 'RedGirasol no ofrece asesoría de inversión.',
					subtitle2: null,
					question: '¿Esperas que RedGirasol te asesore y tome decisiones por ti?',
					value: '0',
					correctValue: '0'
				},
				{
					title: 'Riesgo de pérdida',
					subtitle: 'Al invertir en RedGirasol, tendrás la propiedad de los contratos de crédito en los que participes. Esto significa que recibirás directamente los intereses pagados por los acreditados y que tendrás exposición directa al comportamiento de pago de los mismos.',
					subtitle2: 'Para mitigar este riesgo, construimos un portafolio con cientos de créditos, en el cual participarás desde tu primer depósito. Esto minimiza el impacto en el rendimiento de tu inversión por posibles retrasos y quebrantos.',
					question: '¿Comprendes que serás dueño de un portafolio con cientos de créditos y que tendrás exposición directa? Es decir, recibirás directamente el pago de intereses, cuando sea que los acreditados los realicen, así como tener afectaciones directas por retrasos y quebrantos.',
					value: '1',
					correctValue: '1'
				},
				{
					title: 'Riesgo de liquidez',
					subtitle: 'Con el objetivo de generar interés compuesto diario, todos los días se reinviertirán la totalidad de los pagos que recibas. Todos los días, podrás solicitar un retiro de hasta ' + this.maxEffectiveInvestmentWithdrawalPerInvestorPerDay + ', que estará sujeta a la liquidez disponible por el resto de los Inversionistas de la plataforma. ',
					subtitle2: 'Nota: El monto máximo de liquidez por día, podrá modificarse en el tiempo sin previo aviso.',
					question: '¿Comprendes que todos los días se reinvertirán los pagos recibidos y que la liquidez de tu capital estará sujeta a la liquidez disponible por el resto de los Inversionistas de la plataforma?',
					value: '2',
					correctValue: '1'
				},
				{
					title: 'Riesgo de información',
					subtitle: 'Para fines de transparencia y trazabilidad, podrás consultar diversa información de los créditos que conforman el portafolio. Sin embargo, para proteger la identidad de los Solicitante, no divulgaremos información sensible de los mismos.',
					subtitle2: null,
					question: '¿Comprendes que tendrás acceso limitado a la información de los Solicitantes?',
					value: '3',
					correctValue: '1'
				},
				{
					title: 'Riesgo de rendimiento',
					subtitle: 'El rendimiento que recibas provendrá directamente de los pagos realizados por los acreditados. RedGirasol no ofrece rendimiento fijo. El portafolio de créditos en el que participarás cuenta con una gran diversificación, lo cual disminuye la volatilidad, generando rendimientos estables y predecibles.',
					subtitle2: null,
					question: '¿Comprendes que el rendimiento es variable y depende completamente del comportamiento de pago de los acreditados que conforman el portafolio de créditos?',
					value: '4',
					correctValue: '1'
				},
				{
					title: 'Sin aprobación',
					subtitle: 'Los créditos financiados en RedGirasol son evaluados y calificados por una metodología propia (supervisada por la CNBV). A pesar de que la CNBV supervisa dicha metodología, no revisa ni aprueba los créditos de la plataforma.',
					subtitle2: null,
					question: '¿Comprendes que los créditos son autorizados por RedGirasol y no por la CNBV o alguna otra autoridad financiera?',
					value: '5',
					correctValue: '1'
				},
				{
					title: 'Inversión',
					subtitle: 'Ni el Gobierno Federal ni las entidades de la administración pública paraestatal podrán responsabilizarse o garantizar los recursos de los clientes que sean utilizados en las operaciones que celebren con las ITF o frente a otros, así como tampoco asumir alguna responsabilidad por las obligaciones contraídas por las ITF o por algún cliente frente a otro, en virtud de las operaciones que celebren.',
					subtitle2: null,
					question: '¿Has leído este formulario y comprendes los riesgos de llevar a cabo estas inversiones?',
					value: '6',
					correctValue: '1'
				}
			]
		}
	},
	methods: {
	},
};
</script>